module.exports = __webpack_public_path__ + "static/media/wechat.888e358c.svg";